jQuery(function ($) {
	const modal = "growl-page-breed__modal";
	const card = "growl-component-pet-card";
	let currentPetId = "";

	function renderDate(input) {
		// Empty
		if (!input) {
			return '';
		}

		// Render in locale string
		const date = new Date(input);
		return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
	}

	/**
	 * Set the values within the modal
	 * @param {Node} node HTML node
	 */
	function setModalValues(node) {
		const pet = $(node);
		const id = pet.attr("data-id");
		const price = pet.attr("data-price");
		const gender = pet.attr("data-gender");
		const birthDate = pet.attr("data-birth-date");
		const pictureTakenOn = pet.attr("data-picture-taken-on");
		console.log('pictureTakenOn: ', pictureTakenOn);
		const country = pet.attr("data-country");
		console.log('country: ', country);
		const extraInformation = pet.attr("data-extra-information");
		const image = pet.attr("data-image");

		$(`.${modal}__image`).attr("style", `background-image: url(${image})`);

		$(`.${modal}__picture-taken-on`).parent().css("display", pictureTakenOn.length ? "block" : "none");
		$(`.${modal}__picture-taken-on`).text(renderDate(pictureTakenOn));

		$(`.${modal}__price`).parent().css("display", price ? "block" : "none");
		$(`.${modal}__price`).text(`€ ${price}`);

		$(`.${modal}__gender`).parent().css("display", gender ? "block" : "none");
		$(`.${modal}__gender`).text(gender);

		$(`.${modal}__birth-date`).parent().css("display", birthDate ? "block" : "none");
		$(`.${modal}__birth-date`).text(renderDate(birthDate));

		$(`.${modal}__country`).parent().css("display", country.length ? "block" : "none");
		$(`.${modal}__country`).text(country);

		$(`.${modal}__extra-information`).parent().css("display", extraInformation ? "block" : "none");
		$(`.${modal}__extra-information`).text(extraInformation);

		$("input[name=input_7]").val(gender);
		$("input[name=input_12").val(id);
		currentPetId = id;
	};

	// Set values on opening modal
	$(`[data-popup-trigger="reserve-pet"]`).on("click", function (e) {
		setModalValues($(this));
	});

	// Determine indexes of available pets
	const availablePets = [];
	$(`.${card}`).each(function (index) {
		if ($(this).attr("data-status") === "AVAILABLE") {
			availablePets.push(index);
		}
	});

	// Hide next and previous button
	if (availablePets.length === 1) {
		$(`.${modal}__buttons`).hide();
	}

	// Walking through available pets from within modal
	$(`.${modal}__button`).on("click", function (e) {
		const maxIndex = availablePets.length - 1;
		const currentIndex = availablePets.findIndex((value) => value === $(`[data-id="${currentPetId}"]`).index());
		const direction = $(this).attr("data-direction");

		if (direction === "next") {
			// Next
			if (maxIndex > currentIndex) {
				setModalValues($(`.${card}`)[availablePets[currentIndex + 1]]);
			}

			// First
			else {
				setModalValues($(`.${card}`)[availablePets[0]]);
			}
		}

		if (direction === "previous") {
			// Previous
			if (maxIndex === currentIndex || (maxIndex > currentIndex && currentIndex !== 0)) {
				setModalValues($(`.${card}`)[availablePets[currentIndex - 1]]);
			}

			// Last
			else {
				setModalValues($(`.${card}`)[availablePets[maxIndex]]);
			}
		}
	});
});
